import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { boolean, date, object, string } from 'yup';

import { useAlerta, useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, {
  Botao,
  CaixaDeSelecao,
  CaixaDeTexto,
  Campo,
  Contexto,
} from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Indisponibilidade from 'Interface/Indisponibilidades';
import { Erro } from 'Interface/Requisicao';
import { useAppSelector } from 'Store';
import { recuperarMensagemDeErro } from 'View/functions';
import { useAdicionarIndisponibilidadeMutation } from 'View/Service/Default/Indisponibilidades';

const regras = object({
  dia_inteiro: boolean().nullable().optional(),
  inicio: date()
    .min(
      DateTime.now().plus({ hours: 24 }).toJSDate(),
      'Escolha uma data posterior'
    )
    .required('Obrigatório'),
  termino: date()
    .min(
      DateTime.now().plus({ hours: 24 }).toJSDate(),
      'Escolha uma data posterior'
    )
    .required('Obrigatório'),
  motivo: string().nullable().optional(),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const alerta = useAlerta();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const [adicionarIndisponibilidade] = useAdicionarIndisponibilidadeMutation();

  const enviar = async (dados: Indisponibilidade): Promise<void> => {
    try {
      await adicionarIndisponibilidade({
        ...dados,
        tipo: 2,
        dia_inteiro: dados.dia_inteiro ? 1 : 0,
        usuario_id: usuario?.id,
      }).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/indisponibilidades');
    } catch (error) {
      const teste = error as Erro;

      alerta({
        tema: 'danger',
        titulo: 'Erro!',
        conteudo: recuperarMensagemDeErro(teste.data.errors),
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Solicitar folga"
        descricao="Preencha o formulário e clique em enviar para solicitar uma folga"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="bg-white shadow-sm rounded p-4">
              <p>
                Caso queira solicitar somente um dia de folga, coloque a mesma
                data no campo início e término.
              </p>
              <div className="row">
                <div className="col-md-12">
                  <CaixaDeSelecao name="dia_inteiro" rotulo="Dia inteiro" />
                </div>
                <Contexto>
                  {({ values }) => (
                    <React.Fragment>
                      <div className="col-md-6">
                        <Campo
                          type={values['dia_inteiro'] ? 'date' : 'datetime-local'}
                          name="inicio"
                          rotulo="Início"
                        />
                      </div>
                      <div className="col-md-6">
                        <Campo
                          type={values['dia_inteiro'] ? 'date' : 'datetime-local'}
                          name="termino"
                          rotulo="Término"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </Contexto>
              </div>
              <CaixaDeTexto name="motivo" rotulo="Motivo" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink
                  tema="light"
                  to="/indisponibilidades"
                  className="ms-2"
                >
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
